module.exports = __webpack_public_path__ + "/images/rd_station.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/rd_station.svg
// module id = 625
// module chunks = 0